import apiClient from './apiClient';

// ==================== EMPLOYEES ====================

export const getEmployees = async () => {
  const response = await apiClient.get('/auth/employees/');
  return response.data;
};

export const getEmployee = async (id) => {
  const response = await apiClient.get(`/auth/employees/${id}/`);
  return response.data;
};

export const createEmployee = async (data) => {
  // Promote existing user to employee (staff)
  const response = await apiClient.post('/auth/employees/create/', data);
  return response.data;
};

export const updateEmployee = async (id, data) => {
  const response = await apiClient.patch(`/auth/employees/${id}/`, data);
  return response.data;
};

// ==================== ROLES ====================

export const getRoles = async () => {
  const response = await apiClient.get('/auth/roles/');
  return response.data;
};

export const getRole = async (id) => {
  const response = await apiClient.get(`/auth/roles/${id}/`);
  return response.data;
};

export const createRole = async (data) => {
  const response = await apiClient.post('/auth/roles/', data);
  return response.data;
};

export const updateRole = async (id, data) => {
  const response = await apiClient.patch(`/auth/roles/${id}/`, data);
  return response.data;
};

export const deleteRole = async (id) => {
  const response = await apiClient.delete(`/auth/roles/${id}/`);
  return response.data;
};

// ==================== PERMISSIONS ====================

export const getAvailablePermissions = async () => {
  const response = await apiClient.get('/auth/permissions/');
  return response.data;
};
